import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { Goicuoc5gAction } from 'src/actions/goicuoc5g.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    Box,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    MenuItem,
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';

import {
    DatePicker,
    LocalizationProvider,
  } from '@mui/x-date-pickers';
  import {
    DEFAULT_ROW_PER_PAGE,
    LOAI_GOI_CUOC,
    POST_EDITOR_FONTS,
    POST_EDITOR_FONT_SIZES,
  } from 'src/utils/constants';
  import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';

import PostEditor from "../../components/PostEditor";
import ImageUploader from "../../components/ImageUploader";

const CreateEditDialog = (props) => {
    const dispatch = useDispatch()
    const [selectedPermissionIds, setSelectedPermissionIds] = useState([]);
    const { role } = useSelector(state => state.profile);
    const { items } = useSelector(state => state.permission)
    const { selected } = useSelector(state => state.goicuoc5g)

    const [name, setName] = useState("");
    const [price, setPrice] = useState(0);
    const [price_new, setPriceNew] = useState(0);
    const [operator, setOperator] = useState("-99");
    const [number_type, setNumberType] = useState("-99");
    const [loai_goi_cuoc, setLoaiGoiCuoc] = useState({});
    const [time_by_day, setTimeByDay] = useState(0);
    const [tam_dung, setTamDung] = useState("-99");
    const [short_description, setShortDescription] = useState("");
    const [description, setDescription] = useState("");

    const danhSachLoaiGoiCuoc = LOAI_GOI_CUOC;

    useEffect(() => {
        if (items.length > 0) {
            return;
        }
        dispatch(PermissionAction.list(0, 100))
    }, [])

    useEffect(() => {
        if (props.type === 'EDIT') {
            if (selected) {
                setName(selected.name)
                setPrice(selected.price)
                setPriceNew(selected.price_new)
                setOperator(selected.operator)
                setNumberType(selected.number_type)
                setTimeByDay(selected.time_by_day)
                setTamDung(selected.tam_dung.toString())
                setShortDescription(selected.short_description)
                setDescription(selected.description)

                setLoaiGoiCuoc({})

                if (selected.types && Object.keys(selected.types).length > 0) {
                    let inputLoaiGoiCuoc = {};

                    Object.entries(selected.types).forEach(([key, value]) => {
                        inputLoaiGoiCuoc[value.loai_goi_cuoc] = 1;
                    });

                    setLoaiGoiCuoc(inputLoaiGoiCuoc);
                }
            }
        }
    }, [selected])

    const onPressPositive = async () => {
        console.log("description:", description);

        if (name === "") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (price === "") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (operator === "" || operator == "-99") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (number_type === "" || number_type == "-99") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (time_by_day === "") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (tam_dung === "" || tam_dung == "-99") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (short_description === "") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (description === "") {
            alert("Những trường * là bắt buộc");
            return;
        }

        let outputLoaiGoiCuoc = [];

        if (Object.keys(loai_goi_cuoc).length > 0) {
            Object.entries(loai_goi_cuoc).forEach(([key, value]) => {
                if (value == 1) {
                    outputLoaiGoiCuoc.push(key);
                }
            });
        }

        if (outputLoaiGoiCuoc.length < 1) {
            alert('Vui lòng chọn ít nhất 1 loại gói cước!');
            return;
        }

        if (props.type === 'EDIT') {
            dispatch(Goicuoc5gAction.update(selected.id, { 
                name,
                price,
                price_new,
                operator, 
                number_type,
                loai_goi_cuoc: outputLoaiGoiCuoc,
                time_by_day,
                tam_dung,
                short_description,
                description,
            }))
            resetState();
            props.handleClose();
        } else {
            try {
                const response = await dispatch(Goicuoc5gAction.create({ 
                    name,
                    price,
                    price_new,
                    operator, 
                    number_type,
                    loai_goi_cuoc: outputLoaiGoiCuoc,
                    time_by_day,
                    tam_dung,
                    short_description,
                    description,
                }))
                resetState();
                props.handleClose();
            } catch (error) {
                if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
            }
        }
        
    }

    const resetState = () => {
        setName("")
        setPrice(0)
        setPriceNew(0)
        setOperator("-99")
        setNumberType("-99")
        setLoaiGoiCuoc({})
        setTimeByDay(0)
        setTamDung("-99")
        setShortDescription("")
        setDescription("")
    }

    const chonLoaiGoiCuoc = (e, value) => {
        setLoaiGoiCuoc({
            ...loai_goi_cuoc,
            [value]: e.target.value == 1 ? 2 : 1
        })
    }

    const setColor = (value) => {
        if (value == 'MOBIFONE') return 'green';
        else if (value == 'VINAPHONE') return 'blue';
        else if (value == 'VIETTEL') return 'red';
        else return '#000000';
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Dialog open={props.open} onClose={props.handleClose}>
                <DialogTitle>{props.type === 'EDIT' ? "Cập nhật bản ghi" : "Tạo bản ghi mới"}</DialogTitle>
                <DialogContent style={{ width: 600, paddingTop: 20 }}>
                    <Grid
                        container
                        spacing={3}
                    >
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Tên"
                                name="name"
                                onChange={(e) => setName(e.target.value)}
                                required
                                value={name}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Mô tả ngắn"
                                name="short_description"
                                onChange={(e) => setShortDescription(e.target.value)}
                                required
                                value={short_description}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Giá"
                                name="price"
                                onChange={(e) => setPrice(e.target.value)}
                                required
                                value={price}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Giá khuyến mãi"
                                name="price_new"
                                onChange={(e) => setPriceNew(e.target.value)}
                                value={price_new}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Thời hạn theo ngày"
                                name="time_by_day"
                                onChange={(e) => setTimeByDay(e.target.value)}
                                required
                                value={time_by_day}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <Select1
                                style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                                name="operator"
                                value={operator || -99}
                                onChange={(e) => setOperator(e.target.value)}
                                variant="outlined"
                                startAdornment={(
                                    <InputAdornment position="start">
                                    <SvgIcon fontSize="small" color="action">
                                        <SearchIcon />
                                    </SvgIcon>
                                    </InputAdornment>
                                )}
                                >
                                <MenuItem value="-99">Nhà mạng *</MenuItem>
                                <MenuItem value="MOBIFONE" style={{color: setColor('MOBIFONE')}}>MOBIFONE</MenuItem>
                                <MenuItem value="VINAPHONE" style={{color: setColor('VINAPHONE')}}>VINAPHONE</MenuItem>
                                <MenuItem value="VIETTEL" style={{color: setColor('VIETTEL')}}>VIETTEL</MenuItem>
                            </Select1>
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <Select1
                                style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                                name="number_type"
                                value={number_type || -99}
                                onChange={(e) => setNumberType(e.target.value)}
                                variant="outlined"
                                startAdornment={(
                                    <InputAdornment position="start">
                                    <SvgIcon fontSize="small" color="action">
                                        <SearchIcon />
                                    </SvgIcon>
                                    </InputAdornment>
                                )}
                                >
                                <MenuItem value="-99">Loại thuê bao *</MenuItem>
                                <MenuItem value="1" style={{color: setColor('')}}>TRẢ TRƯỚC</MenuItem>
                                <MenuItem value="2" style={{color: setColor('')}}>TRẢ SAU</MenuItem>
                                <MenuItem value="3" style={{color: setColor('')}}>TT & TS</MenuItem>
                            </Select1>
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <Select1
                                style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                                name="tam_dung"
                                value={tam_dung || -99}
                                onChange={(e) => setTamDung(e.target.value)}
                                variant="outlined"
                                startAdornment={(
                                    <InputAdornment position="start">
                                    <SvgIcon fontSize="small" color="action">
                                        <SearchIcon />
                                    </SvgIcon>
                                    </InputAdornment>
                                )}
                                >
                                <MenuItem value="-99">Trạng thái *</MenuItem>
                                <MenuItem value="0" style={{color: setColor('')}}>Hoạt động</MenuItem>
                                <MenuItem value="1" style={{color: setColor('')}}>Tạm dừng</MenuItem>
                            </Select1>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <Typography
                                variant="body1"
                                color="gray"
                            >
                                <h3>Loại gói cước *</h3>
                            </Typography>
                        </Grid>
                        {Object.entries(danhSachLoaiGoiCuoc).map(([key, value]) => (
                            <Grid item md={6} xs={6} key={key} style={{paddingTop: 0}}>
                                <Typography
                                    className='checkbox-container'
                                    variant="body1"
                                >
                                    <div style={{width: '30px'}}>
                                        <Checkbox
                                            checked={loai_goi_cuoc[key] == 1 ? true : false}
                                            onChange={(event) => chonLoaiGoiCuoc(event, key)}
                                            value={loai_goi_cuoc[key] == 1 ? 1 : 2}
                                            style={{ width: '20px' }}
                                        />
                                    </div>
                                    <div style={{padding: 0}}>
                                        {value}
                                    </div>
                                </Typography>
                            </Grid>
                        ))}
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <Typography
                                className='checkbox-container'
                                variant="body1"
                            >
                                Mô tả *
                            </Typography>
                            <div>
                                <PostEditor
                                    onChange={(value) => {
                                        setDescription(value);
                                    }}
                                    initialContent={description !== "" ? description : ""}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handleClose}>Huỷ</Button>
                    <Button onClick={onPressPositive}>{props.type === 'EDIT' ? "Cập nhật" : "Tạo"}</Button>
                </DialogActions>
            </Dialog >
        </LocalizationProvider>
    );
}

export default CreateEditDialog;